export default class AsdXMLHttpRequest extends XMLHttpRequest {

    constructor(caller) {
        super();
        this.caller = caller;
    }
}